import styled from 'styled-components';

import Icon from 'components/ui/Icon';

const ActionIcon = styled(Icon)`
  cursor: pointer;
`;

export default ActionIcon;
